import React from 'react';
import styles from './PaymentInvoices.module.css';
import { STATUS_LABEL } from './helpers';

// Allowed transitions per status.
// Only EMAILSENT can be manually moved to OVERDUE or PAID.
const TRANSITIONS = {
  GENERATED: [
    {
      status: 'EMAILSENT',
      label: 'Sent Email',
      bg: '#2980b9',
      bgHover: '#1f618d',
    },
  ],
  EMAILSENT: [
    {
      status: 'EMAILSENT',
      label: 'Sent Email',
      bg: '#2980b9',
      bgHover: '#1f618d',
    },
    {
      status: 'PAID',
      label: 'Mark as Paid',
      bg: '#15803d',
      bgHover: '#166534',
    },
  ],
};

const UpdateStatusModal = ({
  isOpen,
  invoice,
  isUpdating,
  updateError,
  onConfirm,
  onClose,
}) => {
  if (!isOpen || !invoice) return null;

  const transitions = TRANSITIONS[invoice.status] ?? [];

  const currentTransitionSelected = React.useRef(null);

  return (
    <div
      className={styles.modalBg}
      onClick={e => e.target === e.currentTarget && onClose()}
    >
      <div className={styles.modalBox} style={{ width: 380 }}>
        <div className={styles.modalTitle}>Update Invoice Status</div>
        <div className={styles.modalSub}>
          <span style={{ fontFamily: 'monospace', color: 'var(--or)' }}>
            {invoice.invoiceNumber}
          </span>
          {' · '}Current:{' '}
          <strong>{STATUS_LABEL[invoice.status] ?? invoice.status}</strong>
        </div>

        {updateError && (
          <div
            style={{
              padding: '10px 14px',
              background: '#fff0f0',
              border: '1px solid #f5c2c2',
              borderRadius: 8,
              marginBottom: 14,
              fontSize: 12.5,
              color: '#c0392b',
            }}
          >
            {updateError.message || 'An unexpected error occurred.'}
          </div>
        )}

        <div
          className={styles.modalActions}
          style={{ flexDirection: 'column', gap: 8, marginTop: 4 }}
        >
          {transitions.map(t => (
            <button
              key={t.status}
              className={styles.btn}
              style={{
                justifyContent: 'center',
                padding: 11,
                background: t.bg,
                borderColor: t.bg,
                color: '#fff',
                fontWeight: 600,
              }}
              disabled={isUpdating}
              onClick={() => {
                currentTransitionSelected.current = t.status;
                onConfirm(invoice.companyInvoiceId, t.status);
              }}
            >
              {isUpdating && t.status === currentTransitionSelected.current
                ? 'Updating…'
                : t.label}
            </button>
          ))}
          <button
            className={`${styles.btn} ${styles.btnSecondary}`}
            style={{ justifyContent: 'center', padding: 11 }}
            disabled={isUpdating}
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateStatusModal;
